import React from 'react';
import { useTranslation } from 'react-i18next';

import { useSciDomain, LoaderRenderer } from 'components';
import { OrderStatus } from 'enums';
import { TranslationNamespace } from 'i18n';
import { PaymentLoadingViewProps } from 'types';

export const DefaultPaymentLoading: React.FC<PaymentLoadingViewProps> = ({
  status,
}) => {
  const { data: { loader } = {} } = useSciDomain();
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.payment_loading',
  });

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-w-full tw-max-w-2xl tw-mx-auto tw-p-16 tw-rounded-2xl tw-bg-payment-layout-out md:tw-py-40">
      <LoaderRenderer
        loaderUrl={loader}
        imageClassName="tw-w-48 tw-mb-8 tw-animate-pulse"
        showCountdown={status === OrderStatus.Requisites}
      />
      {status === OrderStatus.TraderConfirm && (
        <div className="tw-mt-6 tw-flex tw-flex-col tw-items-center tw-gap-1 tw-text-center">
          <span className="tw-text-lg tw-font-medium tw-text-primary">
            {t('waiting_title')}
          </span>
          <span className="tw-text-sm tw-text-secondary">
            {t('waiting_subtitle')}
          </span>
        </div>
      )}
    </div>
  );
};
